import request from "./request";
const ct = /iPhone/gi.test(navigator.userAgent) ? '5' : '4'

export function domainUrl(data) {
  return request({
    url: `dmapi/hdop/domainUrl?key=${data}`,
    method: 'get',
    data
  })
}


export function checkCode(data) {
  return request({
    url: `dmapi/hdop/checkCode?shopId=${data.shopId}&joinShopCode=${data.joinShopCode}`,
    method: 'get',
    data
  })
}


//获取店铺名字
export function proxyName(data) {
  return request({
    url: `router/rest?method=fying.shop.proxy.name&v=1.0&aid=1&cid=1&cv=3.0.0&clientType=${ct}&appName=cmd`,
    method: 'post',
    data
  })
}
